import * as React from 'react';
import {
    ShowButton,
    List,
    Datagrid,
    TextField,
    EditButton,
    TextInput,
    Filter,
    ReferenceField,
} from 'react-admin';

const EnvironmentFilter = props => (
    <Filter {...props}>
        <TextInput label="Search" source="q" />
    </Filter>
);

const EnvironmentList = props => (
    <List {...props} filters={<EnvironmentFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="slug" />
            <ReferenceField label="Project" source="project_id" reference="projects">
                <TextField source="name" />
            </ReferenceField>
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export default EnvironmentList;